module.exports = __webpack_public_path__ + "img/YouTube.26a65798.png";